<template name="terms">
  <div id="terms">
    Input your terms and conditions (e.g. a consent form) here.
  </div>
</template>
<style>
</style>
<script>
/**
 * **TODO**: This should be a researcher's consent form. It should come from a
 * a URL to a markdown file described in the `config` from the parent component.
 */
  export default {
    name: 'terms',
    data() {
      return {

      };
    },
  };
</script>
